import styled from 'styled-components'
import { device } from '../../../styles/Breakpoints'
import { MarketoWrapper } from '../../Marketo/MktoForm.styles'

export const BlogHeroContainer = styled.div`
	display: flex;
	flex-direction: column;
	background-color: #fff;

	& > a {
		align-self: start;
	}

	@media ${device.sm} {
		display: grid;
		grid-template-columns: 1.5fr 1fr;
		gap: 30px;
	}
`

export const FeaturedBlogContainer = styled.div`
	display: flex;
	flex-direction: column;
	border: 1px solid var(--grey-44);
	border-radius: 5px;
	transition-duration: 200ms;
	transition-property: box-shadow;

	&:hover {
		box-shadow: 0px 3px 30px rgb(0 0 0 / 15%);
	}

	img {
		width: 100%;
	}

	div {
		padding: 20px;
	}

	time {
		color: var(--grey-22);
	}

	h3 {
		color: var(--dark-grey);
	}
`

export const BlogHeroCopyContainer = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 20px;

	@media ${device.sm} {
		margin-top: 0;
	}

	${MarketoWrapper} {
		border: 2px solid var(--green);
		box-sizing: border-box;
		padding: 20px;
		h3 {
			font-size: 30px;
			text-align: left;
			color: var(--green);
		}
	}
`
